/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationSharedEnrollmentStatusList200,
  GetApiV1CourseregistrationSharedEnrollmentStatusList401,
  GetApiV1CourseregistrationSharedEnrollmentStatusList500,
  GetApiV1CourseregistrationSharedEnrollmentStatusListQueryParams,
  GetApiV1CourseregistrationSharedEnrollmentStatusListQueryResponse,
} from "../../types/courseRegistrationSharedController/GetApiV1CourseregistrationSharedEnrollmentStatusList.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1CourseregistrationSharedEnrollmentStatusListQueryParamsSchema =
  z.object({
    student: z.boolean().default(false),
    includeTags: z.optional(z.string()),
    showBlocked: z.boolean().default(false),
  }) as unknown as ToZod<GetApiV1CourseregistrationSharedEnrollmentStatusListQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationSharedEnrollmentStatusList200Schema =
  z.array(
    z.lazy(() => dropDownListViewModelSchema),
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedEnrollmentStatusList200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationSharedEnrollmentStatusList401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedEnrollmentStatusList401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationSharedEnrollmentStatusList500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedEnrollmentStatusList500>;

export const getApiV1CourseregistrationSharedEnrollmentStatusListQueryResponseSchema =
  z.lazy(
    () => getApiV1CourseregistrationSharedEnrollmentStatusList200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedEnrollmentStatusListQueryResponse>;
